var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isAppLoaded
    ? _c(
        "div",
        { staticClass: "template-container" },
        [
          _c("customer-header"),
          _vm._v(" "),
          _c("customer-sidebar"),
          _vm._v(" "),
          _c(
            "transition",
            { attrs: { name: "fade", mode: "out-in" } },
            [_c("router-view")],
            1
          ),
          _vm._v(" "),
          _c("site-footer"),
        ],
        1
      )
    : _c(
        "div",
        { staticClass: "template-container" },
        [
          _c("font-awesome-icon", {
            staticClass: "fa-spin",
            attrs: { icon: "spinner" },
          }),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }